import { Typography } from '@mui/material';
import { styled } from "@mui/system";

export const TypographyBase = styled(Typography)(({ theme }) => ({
    // fontSize: props.fontSize,
    //fontFamily:"Noto Sans JP",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}));

export const TypographyCountdown = styled(TypographyBase)(({ theme }) => ({
    color: '#cc0036',
    fontWeight: 'bold',
    [theme.breakpoints.up("xs")]: {
        fontSize: '1.0rem'
    },
    [theme.breakpoints.up("sm")]: {
        fontSize: '1.7rem'
    },
    [theme.breakpoints.up("md")]: {
        fontSize: '2.2rem'
    },
}))

export const TypographyCountdownDetail = styled(TypographyBase)(({ theme }) => ({
    color: '#5f2120',
    [theme.breakpoints.up("xs")]: {
        fontSize: '0.8rem'
    },
    [theme.breakpoints.up("sm")]: {
        fontSize: '1.0rem'
    },
    [theme.breakpoints.up("md")]: {
        fontSize: '1.2rem'
    },
}));

export const TypographyInlineCountdown = styled(TypographyBase)(({ theme }) => ({
    color: '#cc0036',
    fontWeight: 'bold',
    [theme.breakpoints.up("xs")]: {
        fontSize: '0.4rem'
    },
    [theme.breakpoints.up("sm")]: {
        fontSize: '0.6rem'
    },
    [theme.breakpoints.up("md")]: {
        fontSize: '0.8rem'
    },
}))

export const TypographyNomal = styled(TypographyBase)(() => ({
    fontSize: '1rem'
}));
export const TypographyNomalBold = styled(TypographyBase)(() => ({
    fontSize: '1rem',
    fontWeight: 'bold',
}));
export const TypographyCheckSell = styled(TypographyBase)(() => ({
    fontSize: '0.8rem',
    fontWeight: 'bold',
}));
export const TypographyAbnomalBold = styled(TypographyBase)(() => ({
    fontSize: '1rem',
    fontWeight: 'bold',
    color: 'red',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
}));
export const TypographyLargeBold = styled(TypographyBase)(() => ({
    fontSize: '1.5rem',
    fontWeight: 'bold',
}));
export const TypographySmall = styled(TypographyBase)(() => ({
    fontSize: '0.6rem'
}));

export const TypographyBold = styled(TypographyBase)(() => ({
    margin: '0',
    fontWeight: 'bold',
    fontSize: '1.5rem'
}));
export const TypographyBoldWrap = styled(TypographyBold)(() => ({
    fontSize: '1.0rem',
    whiteSpace: 'wrap',
}));
export const TypographyTitle = styled(TypographyBold)(() => ({
    fontSize: '2rem',
    border: '1px solid #0A7CB7'
}));
export const TypographyStepTitle = styled(TypographyBold)(() => ({
    whiteSpace: 'wrap',
    fontSize: '1.5rem',
    borderLeft: '10px solid #0A7CB7',
    paddingLeft: '1.5rem',
}));
export const TypographyInstruction = styled(TypographyBase)(() => ({
    whiteSpace: 'wrap',
    fontSize: '1rem',
    // paddingLeft: '1.5rem',
}));
export const TypographyTitleCenter = styled(TypographyTitle)(() => ({
    padding: '10px',
    textAlign: 'center'
}));
export const TypographyTitleLeft = styled(TypographyTitle)(() => ({
    padding: '10px 0',
    textAlign: 'left'
}));
export const TypographySubTitle = styled(TypographyBold)(() => ({
    // padding: '2px 0',
    textAlign: 'left',
    paddingLeft: '16px',
    // marginBottom: '8px',
    borderLeft: '2px solid #007CB0'
}));

export const TypographyGray = styled(TypographyBase)(() => ({
    color: '#6C6C6C',
}));
export const TypographyGrayNomal = styled(TypographyGray)(() => ({
    fontSize: '0.9rem'
}));
export const TypographyGraySmall = styled(TypographyGray)(() => ({
    fontSize: '0.875rem'
}));

export const TypographyWithBr = styled(Typography)(({ theme }) => ({
    // fontSize: props.fontSize,
    //fontFamily:"Noto Sans JP",
    whiteSpace: "pre-line",
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}));

export const HeaderTypographyNomalBold = ({ children }) => (
  <span style={{ fontWeight: 'bold', display: 'block', textAlign: 'center' }}>
    {children}
  </span>
);